import axios from "helpers/_axios";
import hasProperty from "lodash/has";
export const LOADING_TEAM = "LOADING_TEAM";
export const ERROR_TEAM = "ERROR_TEAM";
export const GET_ALL_TEAMS = "GET_ALL_TEAMS";
export const GET_FILTERED_TEAMS = "GET_FILTERED_TEAMS";
export const GET_TEAM = "GET_TEAM";
export const ADD_TEAM = "ADD_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";

export const getAllTeams = ({
  clientId = 0,
  name = "",
  ignoreIds = [],
  page = 1
}) => async dispatch => {
  try {
    dispatch({
      type: LOADING_TEAM,
      payload: true
    });
    const result = await _fetchTeams({
      clientId,
      name,
      ignoreIds,
      page
    });
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    return dispatch({
      type: GET_ALL_TEAMS,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: GET_ALL_TEAMS,
      payload: null
    });
    dispatch({
      type: ERROR_TEAM,
      payload: error
    });
  }
};

export const getFilteredTeams = ({
  clientId = 0,
  uniqueKey = "",
  name = "",
  ignoreIds = [],
  page = 1
}) => async dispatch => {
  try {
    dispatch({
      type: LOADING_TEAM,
      payload: true
    });
    const result = await _fetchTeams({
      clientId,
      name,
      ignoreIds,
      page
    });
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    return dispatch({
      type: GET_FILTERED_TEAMS,
      payload: {
        [uniqueKey]: result.data
      }
    });
  } catch (error) {
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: GET_FILTERED_TEAMS,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_TEAM,
      payload: error
    });
  }
};

async function _fetchTeams({
  clientId = 0,
  name = "",
  ignoreIds = [],
  page = 1
}) {
  return await axios().get(
    `/teams/clients/${clientId}?page=${page}&name=${name}&ignore_ids=${ignoreIds.join(
      ","
    )}`
  );
}

export const getTeam = clientId => async dispatch => {
  try {
    dispatch({
      type: LOADING_TEAM,
      payload: true
    });
    const result = await axios().get(`/teams/${clientId}`);
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: ERROR_TEAM,
      payload: null
    });
    dispatch({
      type: GET_TEAM,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: GET_TEAM,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_TEAM,
      payload: error
    });
  }
};

export const addTeam = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_TEAM,
      payload: true
    });
    const result = await axios().post(`/teams`, data);
    dispatch({
      type: ERROR_TEAM,
      payload: null
    });
    dispatch({
      type: ADD_TEAM,
      payload: result.data.data
    });
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
  } catch (error) {
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: ERROR_TEAM,
      payload: error
    });
  }
};

export const updateTeam = ({ id, data }) => async dispatch => {
  try {
    dispatch({
      type: LOADING_TEAM,
      payload: true
    });
    const result = await axios().put(`/teams/${id}`, data);
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: ERROR_TEAM,
      payload: null
    });
    dispatch({
      type: UPDATE_TEAM,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: ERROR_TEAM,
      payload: error
    });
  }
};

export const deleteTeam = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_TEAM,
      payload: true
    });
    const result = await axios().delete(`/teams/${id}`);
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: ERROR_TEAM,
      payload: null
    });
    dispatch({
      type: DELETE_TEAM,
      payload: result.status
    });
  } catch (error) {
    dispatch({
      type: DELETE_TEAM,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: LOADING_TEAM,
      payload: false
    });
    dispatch({
      type: ERROR_TEAM,
      payload: error
    });
  }
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    payload: null
  });
};
